import { Link } from "react-router-dom";
import { ContainerScreenGeneral } from "../../components";

const NotFound = () => {
  return (
    <ContainerScreenGeneral size={"md"}>
      <div className="d-flex align-items-center justify-content-center">
        <div className="text-center row align-items-center">
          <div className="col-md-6">
            <h1 className="display-1 fw-bold text-primary">404</h1>
          </div>
          <div className="col-md-6">
            <p className="fs-3">
              <span className="text-danger fw-bold">Ups!</span> Página no encontrada.
            </p>
            <p className="fs-5">La página que está buscando no existe.</p>
          </div>
        </div>
      </div>
      <div className="d-grid gap-2 col-8 mx-auto justify-content-center">
        <Link className="btn btn-primary" to={"/"}>
          Ir al menú
        </Link>
      </div>
    </ContainerScreenGeneral>
  );
};

export default NotFound;
